import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import statusActions from "../../../redux/status/actions";
import featureActions from "../../../redux/feature/actions";
import { truncateToTwoDecimals } from "utils/common";
import { postQuery } from 'utils/api';

import ActionButtons from "../../../components/ActionButtons/ActionButtons";


const ClaysOnCanvas = ({category, data}) => {
  // get price
  const rootElement = document.getElementById('root');
  const calculatepriceEndPoint = rootElement?.getAttribute('data-calculateprice') || '';

  const getCalculatedData = async (id, size) => {
    try {
      const response = await postQuery(
        calculatepriceEndPoint,
        {
          action: 'calculateprice',
          payload: {
            id, // id_product_attribute
            size
          }
        }
      );
  
      const price = response?.data?.data?.price;
      const quantity = response?.data?.data?.quantity;
      const entirePrice = response?.data?.data?.entirePrice;
  
      // If price is undefined/null/NaN, fallback to 0
      const _price = typeof price === 'number' && !isNaN(price) ? price : 0;
      const _quantity = typeof quantity === 'number' && !isNaN(quantity) ? quantity : 0;
      const _entirePrice = typeof entirePrice === 'number' && !isNaN(entirePrice) ? entirePrice : 0;
      
      return { price: _price, quantity: _quantity, entirePrice: _entirePrice};
    } catch (error) {
      console.error('Error in getCalculatedData:', error);
      return { price: 0, quantity: 0, entirePrice: 0 };
    }
  }

  /*api integration start*/
  const baseUrl = useSelector(state => state.Feature.imageBaseUrl);
  const dispatch = useDispatch();
  const coloursOnCanvas = useSelector((state) => state.Feature.coloursOnCanvas);
  const priceData = useSelector((state) => state.Feature.priceData);
  const [size, setSize] = useState({});
  const [price, setPrice] = useState({});
  const [quantity, setQuantity] = useState({});
  const [entirePrice, setEntirePrice] = useState({});

  useEffect(() => {
    const init = async () => {
      // Initialize size (sync)
      const initSize = priceData.reduce((acc, item) => {
        acc[item.id_product_attribute] = item.m2;
        return acc;
      }, {});
      setSize(initSize);

      // Initialize price, quantity, and entirePrice (async)
      const priceEntries = {};
      const quantityEntries = {};
      const entirePriceEntries = {};

      await Promise.all(
        priceData.map(async (item) => {
          const { price, quantity, entirePrice } = await getCalculatedData(item.id_product_attribute, item.m2);
          priceEntries[item.id_product_attribute] = Number(price) || 0;
          quantityEntries[item.id_product_attribute] = Number(quantity) || 0;;
          entirePriceEntries[item.id_product_attribute] = Number(entirePrice) || 0;
        })
      );

      setPrice(priceEntries);
      setQuantity(quantityEntries);
      setEntirePrice(entirePriceEntries);
    };

    if (data.length > 0) {
      init();
    }
  }, [coloursOnCanvas]);

  useEffect(() => {
      dispatch(featureActions.updateSize({ size, price, quantity, entirePrice }));
  }, [price]);

  /*api integration end*/

  const removeItem = (id) => {
    dispatch(statusActions.confirmModalActionDefine({
      type: featureActions.REMOVE_COLOUR_0N_CANVAS,
      payload: id,
    }));
  }

  const handleInputChange = async (id, value) => {
    const newSize = { ...size, [id]: value };
    setSize(newSize);

    const calculatedData = await getCalculatedData(id, value);

    const newPrice = { ...price, [id]: calculatedData.price ?? 0};
    const newQuantity = { ...quantity, [id]: calculatedData.quantity ?? 0};
    const newEntirePrice = { ...entirePrice, [id]: calculatedData.entirePrice ?? 0};

    setPrice(newPrice);
    setQuantity(newQuantity);
    setEntirePrice(newEntirePrice);

    dispatch(
      featureActions.updateSize({
        size: newSize,
        price: newPrice,
        quantity: newQuantity,
        entirePrice: newEntirePrice
      })
    );
  };
  console.log(data);
  return (
    <>
      <div className='acp-sm-title'>{category}</div>
      {
        data.map((item, index) => (
          <div key={index} className='acp-oncanvas-grid-row acp-d-flex acp-jc-space-between'>
            <div className='acp-oncanvas-grid-clay'>
              <img src={baseUrl+item.color_medium_image} alt='color'/>
            </div>
            <div>
              <input
                className='acp-input'
                type='number'
                value={size[item.id_product_attribute]}
                // onChange={(e) =>
                //   {
                //     if(e.target.value === 0 || e.target.value ===undefined || e.target.value === null || e.target.value ==='') {
                //       return;
                //     }else{
                //       handleInputChange(item.id_product_attribute, e.target.value)
                //     }
                //   }
                // }
                onChange={(e) => {
                  const newSize = { ...size, [item.id_product_attribute]: e.target.value };
                  setSize(newSize);
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value && value !== '0') {
                    handleInputChange(item.id_product_attribute, value);
                  }
                }}
              />
            </div>
            <div className='acp-unit-price'>
              €{truncateToTwoDecimals(price[item.id_product_attribute])}  
            </div>
            <ActionButtons data={item} id={item.id_product_attribute} name={item.color_name} src={baseUrl+item.color_image} removeItem={removeItem}/>
          </div>
        ))
      }
    </>
  );
};

export default ClaysOnCanvas;